import {
    buildListParams,
    getListData,
    getTotalRecords,
    handleListIconMouseEnter,
    handleListIconMouseLeave,
    listStyles,
    loadStoredJson,
    removeStoredKeys,
    saveStoredValue
} from 'lib/listUtils';
import {
    alpha,
    Box,
    Card,
    CardContent,
    Input,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    Tooltip
} from '@material-ui/core';
import {
    BackspaceOutlined,
    EditTwoTone,
    PictureAsPdfRounded,
    Search,
    VisibilityOutlined
} from '@material-ui/icons';
import theme from 'theme';
import api from 'services/api';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { AlertInformation } from 'components';
import { isFlagAtiva } from 'lib/configUtils';
import { safeSetState } from 'lib/reactUtils';
import { getApiErrorMessage } from 'lib/formUtils';
import { ComboPadraoMultiple } from 'views/Components';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { handleEnabledIconMouseEnter, handleEnabledIconMouseLeave } from 'lib/uiUtils';
import { formatCurrency, formatData, formatDateForInput, formatTime } from 'lib/functions';

class AgendaEscalaFornecedorList extends Component {
    state = {
        searchFilter: loadStoredJson('agendaescalafornecedorSearchFilter', {
            datainicial: '',
            datafinal: '',
            fornecedores: []
        }),
        agendaescalasfornecedores: [],
        listaFornecedores: [],
        configPartner: {},
        isGeneratingReport: false,
        openAlert: false,
        messageAlert: '',
        totalItems: 0,
        page: Number(sessionStorage.getItem('agendaescalafornecedorPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('agendaescalafornecedorRowsPerPage')) || 10,
        sortField: sessionStorage.getItem('agendaescalafornecedorSortField') || 'CODITEMESCALA',
        sortOrder: sessionStorage.getItem('agendaescalafornecedorSortOrder') || 'DESC'
    };

    estilo = listStyles;

    _isMounted = false;

    handleIconMouseEnter = handleListIconMouseEnter;
    handleIconMouseLeave = handleListIconMouseLeave;
    safeSetState = safeSetState;

    /* Eventos do ícone de relatório */
    // ao passar o cursor
    handleReportIconMouseEnter = (event) => {
        const { isGeneratingReport } = this.state;

        handleEnabledIconMouseEnter(event, isGeneratingReport || !this.podeGerarRelatorio());
    };

    // ao remover o cursor
    handleReportIconMouseLeave = (event) => {
        const { isGeneratingReport } = this.state;

        handleEnabledIconMouseLeave(event, isGeneratingReport || !this.podeGerarRelatorio());
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const { searchFilter } = this.state;
        const isAdmPartner = this.props.match.path.startsWith('/admpartner');

        // fornecedores só são carregados para o filtro exclusivo do Adm Partner
        if (isAdmPartner) {
            this.loadFornecedores();
        }

        if (!searchFilter.datainicial || !searchFilter.datafinal) {
            const dataAtual = formatDateForInput(new Date());

            searchFilter.datainicial = searchFilter.datainicial || dataAtual;
            searchFilter.datafinal = searchFilter.datafinal || dataAtual;

            this.setState(
                { searchFilter },
                this.loadAgendaEscalasFornecedor
            );

            return;
        }

        this.loadAgendaEscalasFornecedor();
    };

    /* Paginação */
    componentDidUpdate(prevProps, prevState) {
        const { searchFilter, page, rowsPerPage, sortField, sortOrder } = this.state;

        // persiste filtros, paginação e ordenação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            saveStoredValue('agendaescalafornecedorSearchFilter', searchFilter);
        }

        if (prevState.page !== page) {
            saveStoredValue('agendaescalafornecedorPage', page);
        }

        if (prevState.rowsPerPage !== rowsPerPage) {
            saveStoredValue('agendaescalafornecedorRowsPerPage', rowsPerPage);
        }

        if (prevState.sortField !== sortField) {
            saveStoredValue('agendaescalafornecedorSortField', sortField);
        }

        if (prevState.sortOrder !== sortOrder) {
            saveStoredValue('agendaescalafornecedorSortOrder', sortOrder);
        }
    };

    /* Limpa os filtros e a paginação ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;

        removeStoredKeys([
            'agendaescalafornecedorSearchFilter',
            'agendaescalafornecedorPage',
            'agendaescalafornecedorRowsPerPage',
            'agendaescalafornecedorSortField',
            'agendaescalafornecedorSortOrder'
        ]);
    };

    /* Carrega os fornecedores para o filtro exclusivo do Adm Partner */
    loadFornecedores = async () => {
        try {
            const params = `?page=1&limit=500&transportadora=S`;
            const response = await api.get(`/fornecedor/active/true${params}`);
            const listaFornecedores = response.data.map(fornecedor => ({
                id: fornecedor.codfornecedor,
                item: fornecedor.fantasia
            })).sort((a, b) => a.item.localeCompare(b.item, 'pt-BR', { sensitivity: 'base' }));

            this.safeSetState({ listaFornecedores });
        } catch (error) {
            console.error('Erro ao carregar os fornecedores da agenda de escalas:', error);
        }
    };

    /* Extrai a mensagem de erro de uma resposta em blob */
    getBlobErrorMessage = async (blob, defaultMessage) => {
        try {
            const blobText = await blob.text();

            if (!blobText) {
                return defaultMessage;
            }

            try {
                const parsedMessage = JSON.parse(blobText);

                return (
                    parsedMessage.error ||
                    parsedMessage.message ||
                    parsedMessage.mensagem ||
                    defaultMessage
                );
            } catch (jsonError) {
                return blobText;
            }
        } catch (error) {
            return defaultMessage;
        }
    };

    /* Verifica se o relatório pode ser gerado */
    podeGerarRelatorio = () => {
        const { searchFilter } = this.state;
        const { datainicial, datafinal, fornecedores } = searchFilter;
        const isAdmPartner = this.props.match.path.startsWith('/admpartner');

        if (!datainicial || !datafinal || datainicial !== datafinal) {
            return false;
        }

        if (isAdmPartner) {
            return !!(fornecedores && fornecedores.length === 1);
        }

        return !!sessionStorage.getItem('idPartner');
    };

    /* Gera e baixa o relatório da agenda filtrada */
    onClickGenerateReport = async () => {
        const { isGeneratingReport, searchFilter } = this.state;
        const { datainicial, datafinal, fornecedores } = searchFilter;
        const isAdmPartner = this.props.match.path.startsWith('/admpartner');

        if (isGeneratingReport || !this.podeGerarRelatorio()) {
            return;
        }

        const codfornecedor = isAdmPartner ? fornecedores[0].id : sessionStorage.getItem('idPartner');

        try {
            this.setState({ isGeneratingReport: true })

            const response = await api.post(
                '/partner/generate-report',
                {
                    codfornecedor,
                    datainicial,
                    datafinal
                },
                {
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/pdf'
                    }
                }
            );

            const contentType = response?.headers?.['content-type'] || 'application/pdf';

            // caso o backend retorne JSON ou texto, evita baixar como PDF
            if (contentType.includes('json') || contentType.includes('text/')) {
                const message = await this.getBlobErrorMessage(
                    response.data,
                    'Não foi possível gerar o relatório!'
                );

                throw new Error(message);
            }

            const blob = new Blob(
                [response.data],
                { type: contentType }
            );

            if (!blob.size) {
                throw new Error('O relatório retornado pela API está vazio!');
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.download = `relatorio_transporte_${codfornecedor}_${datainicial}.pdf`;
            link.style.display = 'none';

            document.body.appendChild(link);
            link.click();

            setTimeout(() => {
                link.remove();
                window.URL.revokeObjectURL(url);
            }, 1000);
        } catch (error) {
            console.error(
                'Não foi possível gerar o relatório de transporte:',
                error.response?.data || error
            );

            let message = 'Não foi possível gerar o relatório de transporte!';

            if (error.response?.data instanceof Blob) {
                message = await this.getBlobErrorMessage(
                    error.response.data,
                    message
                );
            } else {
                message = getApiErrorMessage(error, message);
            }

            this.handleOpenAlert(message);
        } finally {
            this.safeSetState({ isGeneratingReport: false });
        }
    };

    /* Carrega a agenda de escalas do fornecedor */
    loadAgendaEscalasFornecedor = async () => {
        const { page, rowsPerPage, searchFilter, sortField, sortOrder } = this.state;
        const { datainicial, datafinal, fornecedores } = searchFilter;
        const idPartner = sessionStorage.getItem('idPartner');
        const isAdmPartner = this.props.match.path.startsWith('/admpartner');

        const filters = [
            {
                field: 'DATAINICIAL',
                value: datainicial
            },
            {
                field: 'DATAFINAL',
                value: datafinal
            }
        ];

        if (isAdmPartner) {
            if (fornecedores && fornecedores.length > 0) {
                filters.push({
                    field: 'CODFORNECEDORTRANSP',
                    value: fornecedores.map(f => f.id).join(','),
                    operator: '_in_'
                });
            }
        } else {
            filters.push({
                field: 'CODFORNECEDORTRANSP',
                value: idPartner
            });
        }

        const params = buildListParams({
            page,
            rowsPerPage,
            sortField,
            sortOrder,
            filters
        });

        try {
            const response = await api.get('/agendaescalafornecedor' + params);

            this.safeSetState({
                agendaescalasfornecedores: getListData(response),
                configPartner: response.data.configPartner || {},
                totalItems: getTotalRecords(response)
            });
        } catch (error) {
            console.error('Erro ao carregar agenda de escalas do fornecedor:', error);

            this.safeSetState({
                agendaescalasfornecedores: [],
                totalItems: 0
            });
        }
    };

    /* Muda a página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, this.loadAgendaEscalasFornecedor);
    };

    /* Muda a quantidade de retornos por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, this.loadAgendaEscalasFornecedor);
    };

    /* Ordena os retornos da grid */
    handleSort = (field) => {
        this.setState((prevState) => {
            const isSameField = prevState.sortField === field;

            return {
                sortField: field,
                sortOrder: isSameField && prevState.sortOrder === 'ASC' ? 'DESC' : 'ASC',
                page: 0
            };
        }, this.loadAgendaEscalasFornecedor);
    };

    /* Renderiza o título ordenável da coluna */
    renderSortLabel = (field, label) => {
        const { sortField, sortOrder } = this.state;

        return (
            <TableSortLabel
                active={sortField === field}
                direction={sortField === field && sortOrder === 'DESC' ? 'desc' : 'asc'}
                onClick={() => this.handleSort(field)}
            >
                {label}
            </TableSortLabel>
        )
    }

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisa os filtros na tela */
    onChangeSearch = (event) => {
        const { name, value } = event.target;

        const searchFilter = {
            ...this.state.searchFilter,
            [name]: (
                name === 'datainicial' || name === 'datafinal'
            ) ? value : (typeof value === 'string') ? value.toUpperCase() : value
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Filtra por fornecedores (somente Adm Partner) */
    onChangeFornecedores = (selected) => {
        this.setState({
            searchFilter: {
                ...this.state.searchFilter,
                fornecedores: selected
            },
            page: 0
        });
    };

    /* Limpa os filtros da tela */
    limpaFiltros = () => {
        const searchFilter = {
            datainicial: formatDateForInput(new Date()),
            datafinal: formatDateForInput(new Date()),
            fornecedores: []
        };

        this.setState({
            searchFilter,
            page: 0
        }, this.loadAgendaEscalasFornecedor);
    };

    render() {
        const {
            agendaescalasfornecedores,
            configPartner,
            isGeneratingReport,
            listaFornecedores,
            messageAlert,
            openAlert,
            page,
            rowsPerPage,
            searchFilter,
            totalItems
        } = this.state;

        const {
            actionIcon,
            filterPaper,
            iconGroup
        } = this.estilo;

        const basePath = this.props.match.path.startsWith('/admpartner') ? '/admpartner' : '/partner';
        const exibeCustoFornecedorTransp = isFlagAtiva(configPartner, 'exibecustofornecedortransp');
        const baixaRelEscTransp = isFlagAtiva(configPartner, 'baixarelesctransp');
        const podeGerarRelatorio = this.podeGerarRelatorio();
        const totalCustoFornecedorTransp = agendaescalasfornecedores.reduce((total, item) => (
            total + Number(item.custofornecedortransp || 0)
        ), 0);

        return (
            <div style={this.estilo}>
                <Paper
                    style={{
                        ...filterPaper,
                        width: '100%'
                    }}
                >
                    <fieldset
                        style={{
                            padding: '6px 12px',
                            border: `1px solid ${theme.palette.grey[400]}`,
                            borderRadius: 12,
                            flex: '0 1 300px',
                            minWidth: 300,
                            justifyContent: 'center'
                        }}
                    >
                        <legend
                            style={{
                                fontSize: 12,
                                fontFamily: 'Calibri, sans-serif',
                                padding: '0 4px',
                                color: theme.palette.grey[700]
                            }}
                        >
                            Período escala
                        </legend>

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8
                            }}
                        >
                            <Input
                                id="datainicial"
                                name="datainicial"
                                type="date"
                                value={searchFilter.datainicial || ''}
                                onChange={this.onChangeSearch}
                                style={{
                                    flex: '0 1 120px',
                                    minWidth: 120
                                }}
                            />

                            <span>a</span>

                            <Input
                                id="datafinal"
                                name="datafinal"
                                type="date"
                                value={searchFilter.datafinal || ''}
                                onChange={this.onChangeSearch}
                                style={{
                                    flex: '0 1 120px',
                                    minWidth: 120
                                }}
                            />
                        </div>
                    </fieldset>

                    {basePath === '/admpartner' && (
                        <Box
                            style={{
                                flex: '0 1 280px',
                                minWidth: 280
                            }}
                        >
                            <ComboPadraoMultiple
                                options={searchFilter.fornecedores || []}
                                label="Fornecedores"
                                itens={listaFornecedores}
                                onSelectionChange={this.onChangeFornecedores}
                            />
                        </Box>
                    )}

                    <span style={iconGroup}>
                        <Tooltip title="Procurar">
                            <Search
                                onClick={this.loadAgendaEscalasFornecedor}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>

                        <Tooltip title="Limpar">
                            <BackspaceOutlined
                                onClick={this.limpaFiltros}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    {baixaRelEscTransp && (
                        <Tooltip title={isGeneratingReport ? 'Gerando relatório...' : 'Baixar relatório'}>
                            <PictureAsPdfRounded
                                onClick={this.onClickGenerateReport}
                                onMouseEnter={this.handleReportIconMouseEnter}
                                onMouseLeave={this.handleReportIconMouseLeave}
                                style={{
                                    cursor: (isGeneratingReport || !podeGerarRelatorio) ? 'not-allowed' : 'pointer',
                                    color: (isGeneratingReport || !podeGerarRelatorio) ? theme.palette.grey[500] : theme.palette.primary.main,
                                    fontSize: 26,
                                    opacity: (isGeneratingReport || !podeGerarRelatorio) ? 0.7 : 1,
                                    pointerEvents: (isGeneratingReport || !podeGerarRelatorio) ? 'none' : 'auto'
                                }}
                            />
                        </Tooltip>
                    )}
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div style={{ minWidth: exibeCustoFornecedorTransp ? 1050 : 900 }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">
                                                {this.renderSortLabel('CODITEMESCALA', 'Nº Escala')}
                                            </TableCell>

                                            <TableCell align="center">
                                                {this.renderSortLabel('HORASERVICO', 'Hora Serviço')}
                                            </TableCell>

                                            <TableCell align="center">
                                                {this.renderSortLabel('DESCSERVICO', 'Serviço')}
                                            </TableCell>

                                            <TableCell align="center">
                                                {this.renderSortLabel('DATASERVICO', 'Data Escala')}
                                            </TableCell>

                                            <TableCell align="center">
                                                {this.renderSortLabel('TOTALPAX', 'Total Pax')}
                                            </TableCell>

                                            {exibeCustoFornecedorTransp && (
                                                <TableCell align="center">
                                                    {this.renderSortLabel('CUSTOFORNECEDORTRANSP', 'Total Custo')}
                                                </TableCell>
                                            )}

                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {agendaescalasfornecedores.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    colSpan={exibeCustoFornecedorTransp ? 7 : 6}
                                                >
                                                    Nenhuma escala encontrada
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        {agendaescalasfornecedores.map(agendaescalafornecedor => {
                                            const permiteEditar =
                                                isFlagAtiva(agendaescalafornecedor, 'informakminifim') ||
                                                isFlagAtiva(agendaescalafornecedor, 'registrafotokm') ||
                                                isFlagAtiva(configPartner, 'informakminifim') ||
                                                isFlagAtiva(configPartner, 'registrafotokm');

                                            return (
                                                <TableRow
                                                    hover
                                                    key={agendaescalafornecedor.coditemescala}
                                                >
                                                    <TableCell align="center">
                                                        {agendaescalafornecedor.coditemescala}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {formatTime(agendaescalafornecedor.horaservico)}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {agendaescalafornecedor.descservico}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {formatData(agendaescalafornecedor.dataservico)}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {agendaescalafornecedor.totalpax}
                                                    </TableCell>

                                                    {exibeCustoFornecedorTransp && (
                                                        <TableCell align="center">
                                                            {formatCurrency(agendaescalafornecedor.custofornecedortransp || 0)}
                                                        </TableCell>
                                                    )}

                                                    <TableCell align="center">
                                                        <span style={iconGroup}>
                                                            {permiteEditar && (
                                                                <Tooltip title="Editar">
                                                                    <Link to={`${basePath}/agendaescalafornecedor/${agendaescalafornecedor.coditemescala}`}>
                                                                        <EditTwoTone
                                                                            onMouseEnter={this.handleIconMouseEnter}
                                                                            onMouseLeave={this.handleIconMouseLeave}
                                                                            style={actionIcon}
                                                                        />
                                                                    </Link>
                                                                </Tooltip>
                                                            )}

                                                            <Tooltip title="Visualizar">
                                                                <Link to={`${basePath}/agendaescalafornecedor/${agendaescalafornecedor.coditemescala}/view`}>
                                                                    <VisibilityOutlined
                                                                        onMouseEnter={this.handleIconMouseEnter}
                                                                        onMouseLeave={this.handleIconMouseLeave}
                                                                        style={actionIcon}
                                                                    />
                                                                </Link>
                                                            </Tooltip>
                                                        </span>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>

                        {exibeCustoFornecedorTransp && (
                            <div
                                style={{
                                    borderBottom: `1px solid ${theme.palette.grey[300]}`,
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    padding: '12px 16px'
                                }}
                            >
                                <div
                                    style={{
                                        padding: '8px 16px',
                                        borderRadius: 12,
                                        border: `1px solid ${theme.palette.info.light}`,
                                        backgroundColor: alpha(theme.palette.info.main, 0.08),
                                        color: theme.palette.info.dark,
                                        fontWeight: 700,
                                        fontSize: 15,
                                        fontFamily: 'Arial',
                                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                                    }}
                                >
                                    Total Custo: R${formatCurrency(totalCustoFornecedorTransp)}
                                </div>
                            </div>
                        )}

                        <TablePagination
                            component="div"
                            count={totalItems}
                            page={page}
                            onPageChange={this.handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            rowsPerPageOptions={[10, 50, 100, 200]}
                            labelRowsPerPage="Registros por página"
                        />
                    </CardContent>
                </Card>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default AgendaEscalaFornecedorList;